import template from './teamRequestCoincidencesMobile.html';
import controller from './teamRequestCoincidencesMobile.controller';
import './teamRequestCoincidencesMobile.scss';

let teamRequestCoincidencesMobileComponent = {
  restrict: 'E',
  bindings: {
    request: '<'
  },
  template,
  controller
};

export default teamRequestCoincidencesMobileComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardDetails/teamRequestCoincidencesMobile/teamRequestCoincidencesMobile.component.js